<template>
  <router-link :to="{ path: btUrl }" :id="btId" :class="btCss"> {{ btText }} </router-link>
</template>

<script>
export default {
  name: 'BaseButtonLink',
  props: {
    btText: {
      type: String,
      required: true
    },
    btUrl: {
      type: String
    },
    btCss: String,
    btId: {
      type: String,
      required: true
    }
  },
  computed: {
  },
  methods: {
  },
  filters: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>
